<template>
  <div class="w-100 flex justify-center items-center">
    <div class="flex justify-center w-1/2">
      <!-- upload file popup  -->
      <vs-popup title="" button-close-hidden :active.sync="uploadPopup">
        <vs-card>
          <div class="upload-btn-wrapper items-center w-full">
            <img class="upload-resume-icon" src="@/assets/images/icons/upload-resume.svg" />
            <button class="btn w-full cursor-pointer" />
            <div class="resume-parser-text absolute text-center w-full">
              <p class="my-2">
                {{ $t("editor.about.resumeParser.title") }}
              </p>
              <p>
                {{ $t("editor.about.resumeParser.size") }}
              </p>
            </div>
            <input type="file" name="myfile" id="file" accept=".doc,.docx,.pdf" ref="file" class="h-full w-full"
              @change="parseResume()" @drag="parseResume()" @drop="parseResume()" />
          </div>
        </vs-card>
      </vs-popup>
      <!-- animated card  -->
      <vs-popup title="" button-close-hidden :active.sync="isScanningCard">
        <!-- <vs-card class="md:px-2 md:py-2"> -->
        <h4 class="font-semibold text-xl">Screening Resume</h4>
        <vs-row class="m-0 mt-4 relative w-full">
          <vs-col class="animation">
            <img src="@/assets/images/icons/resume-parser/fade_boxes.png" class="w-full animation-screen p-4" />
          </vs-col>
        </vs-row>
        <!-- </vs-card> -->
      </vs-popup>
      <!-- animated card  -->
    </div>
  </div>
</template>

<script>
import { failureNotifyService } from "@/services/errors.service.js";
import axios from "axios";
import constants from "@/constants.js";

export default {
  data() {
    return {
      uploadPopup: false,
      parserPopup: true,
      isScanningCard: false,
      fData: new FormData(),
      fPersonalityData: new FormData(),
      fName: null,
      selectFields: [
        {
          title: "Personal Details",
          value: "False",
          src: require("@/assets/images/icons/about.svg"),
          key: "personal_details",
          comparedKey: "personal_details",
        },
        {
          title: "Skills",
          value: "False",
          src: require("@/assets/images/icons/skills.svg"),
          key: "skills",
          comparedKey: "skills",
        },
        {
          title: "Project",
          value: "False",
          src: require("@/assets/images/icons/projects.svg"),
          key: "projects",
          comparedKey: "projects",
        },
        {
          title: "Education",
          value: "False",
          src: require("@/assets/images/icons/educational-qualifications.svg"),
          key: "educational_details",
          comparedKey: "education_details",
        },
        {
          title: "Experience",
          value: "False",
          src: require("@/assets/images/icons/career-history.svg"),
          key: "work_experience",
          comparedKey: "work_details",
        },
        {
          title: "Languages",
          value: "False",
          src: require("@/assets/images/icons/Languages.svg"),
          key: "languages",
          comparedKey: "languages",
        },
        {
          title: "Certificates",
          value: "False",
          src: require("@/assets/images/icons/Certificates.svg"),
          key: "certificates",
          comparedKey: "certifications",
        },
        {
          title: "Interests",
          value: "False",
          src: require("@/assets/images/icons/Interests.svg"),
          key: "interests",
          comparedKey: "interests",
        },
      ],
      jsonResponse: {},
      userId: {},
      selectedFields: ["predicted_competency", "predicted_characteristics"],
    };
  },
  props: ["parseResumePopup", "userInvited"],
  watch: {
    parseResumePopup(newVal) {
      if (newVal) {
        this.$refs.file.value = null;
      }
      if (newVal === true) {
        this.uploadPopup = true;
        this.$emit("closeResumePopup", false);
      }
    },
    userInvited(newVal) {
      if (newVal) {
        this.syncSelectedParsedData();
      }
    },
  },
  methods: {
    parseResume() {
      let file = this.$refs.file.files[0];
      if (file) {
        this.fName = file.name;
        this.fData.set("file", file);
        this.fPersonalityData.append("file", file);
        this.fData.append("mail_invite", "False");
        if (this.fData.get("file").size <= 5242880) {
          this.finalResponse = {};
          this.isScanningCard = true;
          this.uploadPopup = false;
          axios
            .post(`${constants.parserAPI}`, this.fData, {
              headers: {
                "Content-Type": "multipart/form-data",
                //auth daldo
              },
            })
            .then((res) => {
              this.finalResponse = { ...this.finalResponse, ...res.data.response };
              this.$store.commit("parser/SET_JSON_RESPONSE", this.finalResponse);
              // this.$vs.loading.close();
              // this.getPersonality();
            })
            .catch((err) => {
              console.log("err", err);
              const payload = {
                currentThis: this,
                text: err.response.data.Document_Error,
              };
              failureNotifyService(payload);
              //   throw err;
            })
            .finally(() => {
              this.$vs.loading.close();
            });
        } else {
          const payload = {
            currentThis: this,
            title: "File size large",
            text: "File size max 5MB",
          };
          failureNotifyService(payload);
        }
      }
    },
    getPersonality() {
      this.$vs.loading();
      axios
        .post(`${constants.personalityAPI}`, this.fPersonalityData)
        .then((res) => {
          if (res.data.length) {
            res.data.forEach((item) => {
              this.finalResponse = { ...this.finalResponse, ...item };
            });
            this.jsonResponse = this.finalResponse;
            this.$store.commit(
              "parser/SET_USER_JSON_RESPONSE",
              this.jsonResponse
            );
            this.isScanningCard = false;
          }
          this.$vs.loading.close();
          this.getUser();
        })
        .catch(function (error) {
          this.$vs.loading.close();
          throw error;
        });
    },
    getUser() {
      this.$store
        .dispatch("boards/fetchUserByEmail", {
          email: this.jsonResponse.personal_details.contactDetails.email,
        })
        .then((userRes) => {
          if (userRes.data.data.length === 0) {
            // create User if not exist
            this.$store
              .dispatch("users/createUserWhenParsed", {
                email: this.jsonResponse.personal_details.contactDetails.email,
                firstName: this.jsonResponse.personal_details.name.firstName,
                lastName: this.jsonResponse.personal_details.name.lastName,
              })
              .then((res) => {
                this.userId = res._id;
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            this.userId = userRes.data.data[0]._id;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    syncSelectedParsedData() {
      let myObj = {};
      for (let i = 0; i < this.selectFields.length; i++) {
        let keyStatus = this.jsonResponse.hasOwnProperty(
          this.selectedFields[i]
        );
        if (keyStatus === true) {
          myObj[this.selectedFields[i]] =
            this.jsonResponse[this.selectedFields[i]];
        }
      }
      const payload = {
        id: this.userId,
        syncData: myObj,
      };
      this.$vs.loading();
      this.$store
        .dispatch("parser/syncEditor", payload)
        .then((res) => {
          this.$vs.loading.close();
        })
        .catch((err) => {
          throw err;
        });
    },
  },
  mounted() {
    this.jsonResponse = "";
    this.selectFields.forEach((element) => {
      this.fData.append(element.key, "True");
      this.selectedFields.push(element.comparedKey);
    });
    this.fData.append("mail_invite", "False");
    this.fData.append("file", "");
  },
};
</script>

<style lang="scss" scoped>
.upload-btn {
  position: absolute;
  margin: 2.65rem;
  background: rgba(255, 255, 255, 0.35) !important;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  cursor: pointer;
}

.btn {
  /*border: 2px solid gray;*/
  height: 25em;
  color: gray;
  /*background-color: white;*/
  padding: 6em 3em;
  /*border-radius: 8px;*/
  /*font-size: 20px;
    font-weight: bold;*/
  cursor: pointer;
  background: rgba(242, 147, 0, 0.06);
  border: 1px dashed #f29300;
  box-sizing: border-box;
  border-radius: 12px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #848199;
}

.upload-success {
  background-color: lightgreen !important;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}

input {
  cursor: pointer !important;
}

.upload-resume-icon {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.resume-parser-text {
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.resume-parser-text p:nth-child(1) {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: #f29200;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 2px 4px;
  top: 2.5em;
}

.resume-parser-text p:nth-child(2) {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: rgba(242, 146, 0, 0.6);
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 0px 4px;
  top: 3.5em;
}

.animation {
  display: block;
  overflow: auto;
  box-sizing: border-box;

  &-screen {
    height: 27.5em;
  }

  &::after {
    content: "";
    animation: scanline 5s linear infinite;
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    border-radius: 1em;
    cursor: text;
    background-image: linear-gradient(180deg,
        rgba(173, 255, 226, 0) 0%,
        rgba(173, 255, 226, 0.5) 80%);
  }
}

@media only screen and (max-width: 1024px) {
  .animation {
    &-screen {
      height: 33em;
    }
  }
}

@media only screen and (max-width: 660px) {
  .animation {
    &-screen {
      height: 35em;
    }
  }
}

@keyframes scanline {

  0%,
  100% {
    background-position: 0 0;
  }

  50% {
    background-position: 0 28.5em;
  }
}
</style>

<style scoped>
.con-vs-card>>>.vs-card--content,
.con-vs-card {
  margin: 0;
}

.con-vs-popup>>>.vs-popup--header {
  display: none;
}

.con-vs-popup>>>.vs-popup {
  width: 30em;
  height: 33em;
}
</style>
